<div class="login-page">

  <div class="login-card">

    <div class="login-header">

      <h1>
        Paraíso do Cerrado
      </h1>

      <p>
        Acesso administrativo
      </p>

    </div>

    <form
      (ngSubmit)="entrar()"
    >

      <div class="campo">

        <label for="email">
          E-mail
        </label>

        <input
          id="email"
          type="email"
          name="email"
          [(ngModel)]="email"
          placeholder="Digite seu e-mail"
          autocomplete="username"
          [disabled]="carregando"
        />

      </div>


      <div class="campo">

        <label for="senha">
          Senha
        </label>

        <input
          id="senha"
          type="password"
          name="senha"
          [(ngModel)]="senha"
          placeholder="Digite sua senha"
          autocomplete="current-password"
          [disabled]="carregando"
        />

      </div>


      <button
        type="submit"
        [disabled]="carregando"
      >

        <span *ngIf="!carregando">
          Entrar
        </span>

        <span *ngIf="carregando">
          Entrando...
        </span>

      </button>

    </form>

  </div>

</div>
